// Thin wrapper so tests can mock navigation: jsdom does not allow window.location to be redefined or spied on.
export const navigateTo = (url: string): void => window.location.assign(url);
